import { App } from '@ps20-frontend/frontend-models';

export interface IChildAppConfig {
  readonly name: string;
  readonly assignedRoute: string;
  readonly configFilename: string;
  readonly baseUrl: string;
}

const configJsonFilename = 'config.json';

export class ChildAppsConfig {
  getConfig(): Array<IChildAppConfig> {
    return [
      {
        name: App.VWG,
        assignedRoute: '/vwg/angebot',
        baseUrl: '/vwg-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.VWG_V2,
        assignedRoute: '/vwg-v2/angebot',
        baseUrl: '/vwg-angebot-v2/',
        configFilename: configJsonFilename,
      },
      {
        name: App.VHV,
        assignedRoute: '/vhv/angebot',
        baseUrl: '/vhv-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.VHV_V2,
        assignedRoute: '/vhv-v2/angebot',
        baseUrl: '/vhv-angebot-v2/',
        configFilename: configJsonFilename,
      },
      {
        name: App.PH,
        assignedRoute: '/ph/angebot',
        baseUrl: '/ph-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.RS,
        assignedRoute: '/rs/angebot',
        baseUrl: '/rs-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.RS_VERMIETUNG,
        assignedRoute: '/rs-vermietung/angebot',
        baseUrl: '/rs-vermietung-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.UNF,
        assignedRoute: '/unf/angebot',
        baseUrl: '/unf-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.JHP,
        assignedRoute: '/jhp/angebot',
        baseUrl: '/jhp-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.THH_HUND,
        assignedRoute: '/thh-hund/angebot',
        baseUrl: '/thh-hund-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.THH_PFERD,
        assignedRoute: '/thh-pferd/angebot',
        baseUrl: '/thh-pferd-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.TKV,
        assignedRoute: '/tkv/angebot',
        baseUrl: '/tkv-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.TKV_V2,
        assignedRoute: '/tkv-v2/angebot',
        baseUrl: '/tkv-angebot-v2/',
        configFilename: configJsonFilename,
      },
      {
        name: App.TGV,
        assignedRoute: '/tgv/angebot',
        baseUrl: '/tgv-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.GEGE,
        assignedRoute: '/gege/angebot',
        baseUrl: '/gege-angebot/',
        configFilename: configJsonFilename,
      },
      {
        name: App.SHOP_DASHBOARD,
        assignedRoute: '/dashboard',
        baseUrl: '/dashboard/',
        configFilename: configJsonFilename,
      },
      {
        name: App.SHOP_CHECKOUT,
        assignedRoute: '/checkout',
        baseUrl: '/checkout/',
        configFilename: configJsonFilename,
      },
      {
        name: App.SHOP_TOOLBAR,
        assignedRoute: '/',
        baseUrl: '/toolbar/',
        configFilename: configJsonFilename,
      },
    ];
  }

  getConfigUrlForAppId(appId: App): string {
    const appConfig = this.getConfig().find(config => config.name === appId.toString());

    return appConfig ? `${appConfig.baseUrl}${appConfig.configFilename}` : null;
  }

  mapAppNameToAssignedRoute(appName: string): string {
    const configEntry = this.getConfig().find(entry => entry.name === appName);
    return configEntry ? configEntry.assignedRoute : null;
  }

  mapHashToAppName(hash: string): string {
    const route = hash?.startsWith('#') ? hash.slice(1) : hash;
    if (route && route !== '/') {
      const configEntry = this.getConfig().find(entry => route.includes(entry.assignedRoute));
      return configEntry ? configEntry.name : null;
    } else {
      return null;
    }
  }

  mapHashToSubroute(hash: string): string {
    const appName = this.mapHashToAppName(hash);
    const assignedRoute = this.mapAppNameToAssignedRoute(appName || '') || '';
    const subrouteComponents = hash
      .replace('#', '')
      .replace(assignedRoute, '')
      .split('/')
      .filter(Boolean);

    return subrouteComponents.reduce((prev, curr) => `${prev}/${curr}`, '');
  }
}

export const childAppsConfig = new ChildAppsConfig();
